import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/motion";

export default function LegalPage({ title, seoDescription, path, updated, intro, sections }) {
  return (
    <>
      <Seo title={title} description={seoDescription} path={path} />
      <PageHeader eyebrow="Legal" title={title} subtitle={`Last updated ${updated}`} />
      <section className="border-b border-border py-16 sm:py-24">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          {intro && <Reveal className="mb-10 text-base leading-relaxed text-muted-foreground">{intro}</Reveal>}
          <div className="flex flex-col gap-10">
            {sections.map((s, i) => (
              <Reveal key={s.heading} delay={i * 0.04} as="section">
                <h2 className="font-display text-xl font-semibold tracking-tight sm:text-2xl">{s.heading}</h2>
                <div className="mt-4 space-y-4 text-sm leading-relaxed text-muted-foreground sm:text-base">
                  {s.body.map((p, j) =>
                    Array.isArray(p) ? (
                      <ul key={j} className="space-y-2">
                        {p.map((li) => (
                          <li key={li} className="flex items-start gap-2.5">
                            <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-teal" />
                            <span>{li}</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p key={j}>{p}</p>
                    )
                  )}
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-12 rounded-2xl border border-border bg-card p-6 text-sm text-muted-foreground">
            This is a Phase 1 policy for the StUpEco Workspace marketing website and is provided for
            general information. It is not legal advice. Questions? Reach us via the{" "}
            <a href="/contact" className="font-medium text-foreground underline-offset-4 hover:underline">contact page</a>.
          </Reveal>
        </div>
      </section>
    </>
  );
}
